import React, { useEffect, useState } from 'react';
import styles from './AdminCityCreate.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { citySingle } from '../../../redux/actions/app/citySingle';
import { resetCityCreate, resetCityEdit, resetCitySingle } from '../../../redux/slices/app.slice';
import { useDispatch } from 'react-redux';
import { cityEdit } from '../../../redux/actions/app/cityEdit';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';
import { cityCreate } from '../../../redux/actions/app/cityCreate';
import { countryList } from '../../../redux/actions/app/countryList';

const AdminCityCreate = () => {
  const data = [
    [
      {
        label: 'Название',
        type: 'text',
        name: 'name',
      },
      { label: 'Порядок', type: 'number', name: 'order' },
    ],
  ];
  const [fields, setFields] = useState(data);

  const {
    countryList: { data: countryListData, loading: countryListLoading, error: countryListError },
  } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(countryList(0));
  }, []);

  useEffect(() => {
    if (countryListData) {
      setFields([
        [
          {
            label: 'Город',
            type: 'text',
            name: 'name',
          },
          { name: 'citizenshipId', label: 'Страна', type: 'select', options: countryListData?.list?.map((country) => ({ value: country?.id, label: country?.name })) },
        ],
      ]);
    }
  }, [countryListData]);

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    cityCreate: { data: cityCreateData, loading: cityCreateLoading },
  } = useSelector((state) => state.app);
  const navigate = useNavigate();
  useEffect(() => {
    if (cityCreateData) {
      toast.success('Город создан');
      navigate('/admin/city/list');
      dispatch(resetCityCreate());
    }
  }, [cityCreateData]);

  return (
    <>
      <AdminSinglePage
        isCreate
        isBlock={false}
        isDelete={false}
        onSubmit={(data) => {
          console.log(data);
          dispatch(cityCreate(data));
        }}
        reset={resetCitySingle}
        fetch={citySingle}
        sliceName={'app'}
        actionName={'citySingle'}
        fields={fields}
        isSave
        pathList="/admin/city/list"
        propName={'city'}
        type={'USER'}
      />
      {cityCreateLoading && <Loading />}
    </>
  );
};

export default AdminCityCreate;
